import React from "react";
import "./CyientShowcase.css";

const data = [
  {
    title: "IT Services & Solutions",
    description:
      "Delivering end-to-end IT services including software development, cloud solutions, cybersecurity, and enterprise IT support to drive digital transformation.",
    image:
    "https://images.unsplash.com/photo-1681164315014-06bf36b2597a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODU1fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
      
  },
  {
    title: "Non-IT Job Opportunities",
    description:
      "Connecting skilled professionals with roles across manufacturing, operations, administration, and customer services to support diverse industry needs.",
    image:
      "https://images.unsplash.com/photo-1714079761488-e0c9b9ac4138?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTU1fHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
  },
  {
    title: "Other Professional Services",
    description:
      "From HR and finance to consulting and business support services, we provide opportunities that empower growth across multiple career paths.",
    image:
      "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTIzfHxzb2Z0d2FyZXxlbnwwfHwwfHx8Mg%3D%3D"
  }
];

const CyientShowcase = () => {
  return (
    <div className="cyient-showcase-container">
      <h2 className="main-title">
        What We Serve <br />
        <span>Opportunities Across IT, Non-IT, and others</span>
      </h2>
      <div className="cyient-showcase-grid">
        {data.map((item, index) => (
          <div className="showcase-card" key={index}>
            <img src={item.image} alt={item.title} />
            <div className="card-overlay">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CyientShowcase;
